import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { InvoiceScreen } from "../screens/InvoiceScreen";

export const Route = createFileRoute("/prototype/c/$companyId/sales/invoices/$invoiceId")({
  component: SalesInvoice,
});

function SalesInvoice() {
  const { companyId, invoiceId } = Route.useParams();
  return (
    <InvoiceScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      invoiceId={invoiceId}
    />
  );
}
